<app-resources class="resources-list"></app-resources>